import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { useDatabridgeSubscribe } from '@xp-utilities/web';
import { UPPER_FUNNEL_LOGIN_CLIENT_QUERY } from './operations';
import UpperFunnelLogin from './UpperFunnelLogin';
import AuthenticationModal from '../SignIn/AuthenticationModal';
import { PAGE_KINDS } from '../../tools/constants';

// Determine if Upper Funnel Login should be enabled based on the page kind
const useIsUFLEnabledOnPage = (pageKind) => {
  const [isEnabledOnPage, setIsEnabledOnPage] = useState(false);

  useEffect(() => {
    const shouldEnable = pageKind !== PAGE_KINDS.checkout && pageKind !== PAGE_KINDS.cart;
    setIsEnabledOnPage(shouldEnable);
  }, [pageKind]);

  return isEnabledOnPage;
};

export default function UpperFunnelLoginClient() {
  const pageKind = useDatabridgeSubscribe('page.pageKind');
  const isEnabledOnPage = useIsUFLEnabledOnPage(pageKind);

  const { data, error, loading } = useQuery(
    UPPER_FUNNEL_LOGIN_CLIENT_QUERY,
    {
      context: { batch: true },
      fetchPolicy: 'cache-and-network',
      ssr: false,
    },
  );

  if (loading) return null;
  if (error) return null;

  const { userState, config } = data;
  const { isGeneric, isLoggedIn } = userState;
  const { hasUpperFunnelLoginEnabled } = config;

  const renderConditions = [
    hasUpperFunnelLoginEnabled,
    !isLoggedIn,
    isGeneric,
    isEnabledOnPage,
  ];

  const shouldRender = renderConditions.every((condition) => condition);
  if (!shouldRender) return null;

  return (
    <>
      <AuthenticationModal />
      <UpperFunnelLogin />
    </>
  );
}
